import { ButtonElement, ButtonEvent } from "appworks/graphics/elements/button-element";
import { AbstractControl } from "appworks/ui/controls/abstract-control";
import { ygg } from "ygg/ygg";

export class PartnerConnectHomeButtonControl extends AbstractControl {

    constructor(protected button: ButtonElement) {
        super();

        this.enableButton();
    }

    public destroy(): void {
        this.button.removeAllListeners();
    }

    protected enableButton(): void {
        this.button.on(ButtonEvent.CLICK, () => ygg.goToLobby());
        this.button.visible = true;
    }
}
